import type { ConversationResponse, Timestamp, WorkspaceResponse } from "@somewear/api";
import type { IContactForDisplay } from "@somewear/model";

import type { MessageOrFile } from "../messaging/messaging.model";

export interface IConversationBaseEntity extends ConversationResponse.AsObject {
	isLoaded?: boolean;
}
export interface IDirectConversationEntity extends IConversationBaseEntity {
	conversationId: string;
}

export interface IWorkspaceConversationEntity extends IConversationBaseEntity {}

export type IConversationEntity = IDirectConversationEntity | IWorkspaceConversationEntity;

export type ConversationPreview = IConversationEntity & {
	contact?: IContactForDisplay;
	mostRecentMessage?: MessageOrFile;
	workspace?: WorkspaceResponse.AsObject;
	readTimestamp?: Timestamp.AsObject;
	queryMatchedResult?: MessageOrFile;
	previewId?: string;
	numberOfUnreadMessages?: number;
};

export const WORKSPACE_CONVERSATION_PREFIX = "w_";
export const DIRECT_CONVERSATION_PREFIX = "c_";
